import { useState, useImperativeHandle } from 'react';
import BaseModal from '@/components/BaseModal';
import './index.scss';

interface propsType {
  cRef?: any;
  total: number;
}
const SignInOverdue = (props: propsType) => {
  const { cRef, total } = props;
  const [show, setShow] = useState<boolean>(false); //是否展示
  /**
   * @description: 切换弹框状态
   */
  const open = () => {
    setShow(true);
  };
  /**
   * @description: 切换弹框状态
   */
  const close = () => {
    setShow(false);
  };
  // 绑定ref
  useImperativeHandle(cRef, () => ({
    open,
  }));
  return (
    <BaseModal show={show}>
      <div className="signin-overdue">
        <p className="overdue__title">碎片过期提醒</p>
        <p className="overdue__pagation">
          您有{total}碎片将于今天23:59:59就要过期了，
          您可使用碎片到【碎片商城】兑换礼品
        </p>
        <div className="overdue__btn">
          <div className="overdue__btn__allow" onClick={close}>
            我知道了
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

export default SignInOverdue;
